export const calculateLayout = (items, numCols) => {
  if (items.length === 1) {
    return [
      {
        i: items[0].id,
        x: 0,
        y: 0,
        w: 12,
        h: 1,
        static: true,
      },
    ];
  }

  return items.map((item, index) => ({
    i: item.id,
    x: (index % numCols) * (12 / numCols),
    y: Math.floor(index / numCols),
    w: 12 / numCols,
    h: 1,
    static: true,
  }));
};

export const getNumCols = (itemCount) => {
  if (itemCount <= 1) return 1;
  if (itemCount <= 4) return 2;
  if (itemCount <= 6) return 3;
  return 4;
};
